import React, { useState, useEffect, useContext } from 'react';
import { BrowserRouter, Routes, Route, IndexRoute, useParams, Navigate, useLocation } from "react-router-dom";
import TagManager from 'react-gtm-module';

import CircularProgress from '@mui/material/CircularProgress';

import Header from './Components/Layout/Header/Header.jsx';
import Footer from './Components/Layout/Footer/Footer.jsx';

import Dashboard from './Pages/Dashboard/Dashboard.jsx';
import DashboardV1 from './Pages/Dashboard/DashboardV1.jsx';
import Signup from './Pages/Signup/Signup.jsx';
import Login from './Pages/Login/Login.jsx';
import SignupDetails from './Pages/SignupDetails/SignupDetails.jsx';
import SignupPayment from './Pages/SignupPayment/SignupPayment.jsx';
import SignupPaymentConfirmation from './Pages/SignupPaymentConfirmation/SignupPaymentConfirmation.jsx';
import DashboardOnboarding from './Pages/DashboardOnboarding/DashboardOnboarding.jsx';
import Catalog from './Pages/Catalog/Catalog.js';
import Insights from './Pages/Insights/Insights.js';
import Resources from './Pages/Resources/Resources.jsx';
import Support from './Pages/Support/Support.jsx';
import ForgetPassword from './Pages/ForgetPassword/ForgetPassword.js';
import ChangePassword from './Pages/ChangePassword/ChangePassword.jsx';
import Token from './Components/Token/Token.jsx';
import Clients from './Pages/Clients/Clients.jsx';
import CreateAssessment from './Pages/CreateAssessment/CreateAssessment.jsx';
import Sidebar from './Components/Sidebar/Sidebar.js';
import AllClient from './Components/AllClient/AllClient.jsx';
import AddClient from './Components/AddClient/AddClient.jsx';
import AuthContext from './Context/AuthContext.js';
import { ToastContainer } from 'react-toastify';
import TokenCheckout from './Components/TokenCheckout/TokenCheckout.js';
import TokenPaymentSuccessfulPage from './Components/TokenPaymentSucessfulPage/TokenPaymentSuccessfulPage.jsx';
import GeneratePdf from './Pages/GeneratePdf/GeneratePdf.jsx';
import SelfReport from './Pages/GeneratePdf/SelfReport.jsx';
import Report360 from './Pages/GeneratePdf/Report360.jsx';
import GroupReport from './Pages/GeneratePdf/GroupReport.jsx';
import TermsAndConditions from './Modals/TermsAndConditionsModal/TermsAndConditions.jsx';
// ReactGA.initialize('');
// ReactGA.pageview(window.location.pathname + window.location.search);

const tagManagerArgs = {
  gtmId: 'GTM-TPGXKL2X'
}

TagManager.initialize(tagManagerArgs)

function App() {

  // usestates
  const [isLoading, setIsLoading] = useState(false);
  const paths = ["/dashboard/onboarding", "/dashboard", "/catalog", "/insights", "/resources", "/support", "/tokens", "/added-client", "/client", "/clients", "/add-client" , '/token-checkout' , '/token-payment-successful'];


  const authCtx = useContext(AuthContext)

  // useLocation
  const { pathname } = useLocation();

  //useEffect
  useEffect(() => {
  const syncLogin = (e) => {
    if (e.key === 'token') {
      window.location.reload();
    }
  };
  window.addEventListener('storage', syncLogin);
  return () => window.removeEventListener('storage', syncLogin);
}, []);

  if (isLoading) {
    return <div className="container details loading"><CircularProgress style={{ color: '#7D8704' }} size={60} /></div>
  }

  const showSidebar = paths.some(path => {
    const basePath = path.split("/:")[0];
    return pathname.startsWith(basePath);
  });

  const localToken = localStorage.getItem("token");
  const isAuthenticated = authCtx.isLoggedIn || !!localToken;
  
  // console.log('isAuthenticated', isAuthenticated)

  return (
    <div className="App main">
      <main className='dashboard-main-flex' >
        { showSidebar && <Sidebar /> }
        <ToastContainer/>
        <Routes>
          <Route path="/" exact index element={<Navigate to={isAuthenticated ? "/dashboard" : "/signup"} />} />
          <Route path="/signup" exact index element={isAuthenticated ? <Navigate to="/dashboard" /> : <Signup />} />
          <Route path="/login" exact index element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />} />
          <Route path="/forget-password" exact index element={<ForgetPassword />} />
          <Route path="/account/verify" exact index element={<ChangePassword />} />
          <Route path="/signup-details/:orgId" exact index element={<SignupDetails />} />
          <Route path="/signup-payment/:orgId" exact index element={<SignupPayment />} />
          <Route path="/payment-confirmed" exact index element={<SignupPaymentConfirmation />} />
          <Route path="/dashboard/onboarding" exact element={authCtx.isLoggedIn ? <DashboardOnboarding /> : <Navigate to="/login" />}></Route>
          <Route path="/dashboard" exact element={authCtx.isLoggedIn ? <DashboardV1 /> : <Navigate to="/login" />}></Route>
          <Route path="/catalog" exact element={authCtx.isLoggedIn ? <Catalog /> : <Navigate to="/login" />}></Route>
          <Route path="/insights" exact element={authCtx.isLoggedIn ? <Insights /> : <Navigate to="/login" />}></Route>
          <Route path="/resources" exact element={authCtx.isLoggedIn ? <Resources /> : <Navigate to="/login" />}></Route>
          <Route path="/support" exact element={authCtx.isLoggedIn ? <Support /> : <Navigate to="/login" />}></Route>
          <Route path="/tokens" exact element={authCtx.isLoggedIn ? <Token /> : <Navigate to="/login" />}></Route>
          <Route path="/token-checkout" exact element={authCtx.isLoggedIn ? <TokenCheckout /> : <Navigate to="/login" />}></Route>
          <Route path="/token-payment-successful" exact element={authCtx.isLoggedIn ? <TokenPaymentSuccessfulPage /> : <Navigate to="/login" />}></Route>
          <Route path="/added-client/:id" exact element={authCtx.isLoggedIn ? <Clients /> : <Navigate to="/login" />}></Route>
          <Route path="/client/:id" exact element={authCtx.isLoggedIn ? <CreateAssessment /> : <Navigate to="/login" />}></Route>
          <Route path="/clients" exact element={authCtx.isLoggedIn ? <AllClient /> : <Navigate to="/login" />}></Route>
          <Route path="/add-client" exact element={authCtx.isLoggedIn ? <AddClient /> : <Navigate to="/login" />}></Route>
          <Route path="/generate-pdf" exact element={authCtx.isLoggedIn ? <GeneratePdf /> : <Navigate to="/login" />}></Route>
          <Route path="/self-report-pdf" exact element={authCtx.isLoggedIn ? <SelfReport /> : <Navigate to="/login" />}></Route>
          <Route path="/report-360-pdf" exact element={authCtx.isLoggedIn ? <Report360 /> : <Navigate to="/login" />}></Route>
          <Route path="/group-report-pdf" exact element={authCtx.isLoggedIn ? <GroupReport /> : <Navigate to="/login" />}></Route>
        </Routes>
      </main>
      {/* </AssessmentProgressContextProvider> */}
    </div>
  );
}

export default App;
